export const COLORS = {
  void: "#0d1117",
  skyDeep: "#111827",
  skyMid: "#1e2d3d",
  horizon: "#2a3f52",
  stoneDark: "#3a3630",
  stoneMid: "#5a5248",
  stoneLight: "#7a6e62",
  mossDark: "#2d3a20",
  mossMid: "#4a5e32",
  ground: "#1a2010",
  rune: "#00e5cc",
  runeDim: "#00a896",
};
